<template>
    <div class="provider-create mb-3 mt-page">

        <h1>{{ $i18n.gt('HEADING_ADOPT_PATIENT') }}</h1>
        <b-row>
            <b-col offset="3" cols="6">
                <b-row>
                    <b-col cols="9">
                        <b-form-group :label="$i18n.gt('LABEL_SEARCH_FOR_PATIENT')">
                            <b-form-input type="email"
                                          :placeholder="$i18n.gt('LABEL_EMAIL')"
                                          v-model="email"
                                          @input="resetSearch()">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3" class="text-right">
                        <b-btn variant="primary" class="mt-4"
                               @click="search()">
                            {{ $i18n.gt('LABEL_SEARCH') }}
                        </b-btn>
                    </b-col>
                </b-row>
                <b-row>
                    <b-alert variant="warning"
                             :show="haveSearched && !participant">
                        {{ $i18n.gt('LABEL_NO_PATIENT_EMAIL') }}
                    </b-alert>
                </b-row>

                <div v-if="participant">
                    <b-card title="Patient found">
                        {{ participant.fullname }}<br/>
                        {{ $i18n.gt('LABEL_DOB') }}: {{ participant.dob }}<br/>
                        {{ participant.email }}<br/>
                    </b-card>

                    <b-row>
                        <b-col cols="6">
                            <b-form-group label="Add with Provider Type">
                                <b-form-select :options="typeOptions"
                                               v-model="providerType">
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6" class="text-right">
                            <b-btn variant="success" class="mt-4"
                                   :disabled="!providerType"
                                   @click="addProvider()">
                                {{ $i18n.gt('LABEL_ADD_PATIENT_ROSTER') }}
                            </b-btn>
                        </b-col>
                    </b-row>
                </div>

            </b-col>
        </b-row>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'
    import * as _ from 'lodash'

    /**
     * Page for a Practitioner to create a Provider record for a selected Participant,
     * in order to bring them into the Practice
     */
    export default Vue.extend({
        name: 'provider-create',
        data () {
            return {
                haveSearched: false,
                email: null,
                participant: null,
                providerType: null,

                typeOptions: [
                    { value: 'PRIMARY', text: 'Primary Care' },
                    { value: 'COACH', text: 'Health Coach' },
                    { value: 'MENTOR', text: 'Health Mentor' },
                ]
            }
        },
        computed: {
            canAddProvider () {
                return this.addProviderPractice.id != null &&
                    this.addProviderType != null
            }
        },
        methods: {
            search () {
                this.$api.findParticipants(this, this.email)
                    .then((items) => {
                        if (items.length == 1 && _.toLower(items[0].user.email) == _.toLower(this.email)) {
                            this.participant = items[0]
                        }
                        this.haveSearched = true
                    })
            },
            resetSearch () {
                this.participant = null
                this.haveSearched = false
            },
            addProvider () {
                const provider = {
                    participant_id: this.participant.id,
                    practice_id: this.$user.practitionerPracticeId(),
                    type: this.providerType
                }
                this.$api.createItem(this, 'provider', provider)
                    .then((response) => {
                        this.$toasted.show('Patient added', { duration: 3000 })
                        this.$router.replace('/')
                    })
            }
        },
    })

</script>
